// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".artist-promo[data-v-8f9b0198]{height:243px;background-size:cover;background-position:center}.artist-promo-wrapper[data-v-8f9b0198]{background:linear-gradient(90.15deg, #3C3C3C 0.11%, #A4A4A4 81.1%);position:relative}@media(max-width: 1199.98px){.artist-promo[data-v-8f9b0198]{height:176px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
